<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('coupons_overview.page_title') }}</slot>
            <slot slot="description">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/coupons/create">{{ $t('coupons_overview.create') }}</router-link>
            </slot>
        </page-header>

        <v-overview-list
            prefix="a1"
            data-table="CouponOptions"
            btnViewPath="CouponsEdit"
            :table-columns="Columns"
            :page-size="100">

            <template slot="placeholderButtonsFooter">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/coupons/create">{{ $t('coupons_overview.create') }}</router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            Columns() {
                return [
                  {
                      value: 'Code',
                      name: this.$t('coupons_overview.columns.code'),
                      sortable: false
                  },
                  {
                      value: 'DisplayType',
                      name: this.$t('coupons_overview.columns.type'),
                      sortable: false
                  },
                  {
                      value: 'From',
                      name: this.$t('coupons_overview.columns.from'),
                      type:'Date',
                      sortable: false
                  },
                  {
                      value: 'To',
                      name: this.$t('coupons_overview.columns.to'),
                      type:'Date',
                      sortable: false
                  }
              ];
            }
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/coupons/Overview.vue